<template>
    <PopupRouterViewDetail label="Finish Good Qc Confirmation Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Finish Good Quality Inspection" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" type="generatednumber" label="FG QC Number" :model="model.requestNumber" />
						<app-input-combobox-autocomplete :options="userInfos" optionsLabel="firstName" optionsKey="userName" label-cols-lg="12" label="QC By" id="fieldset-process-by" size="sm" :model.sync="model.processByUserName" :isRequired="true" :state="validateState('processById')" :errorMessage="getErrorMessage(errorMessage.processById, 'processById')"   :selected="model.processBy != null ? model.processBy.firstName : ''" @input="getUserInfos" @change="updateData" :isEditable="false" :isUpdatable="false" :isSelectMethodExists="true" @onSelectMethod="setSelectedProcessBy" />
						<app-input-datepicker  id="fieldset-qc-date" label-cols-lg="12"  label="QC Date" size="sm" :model.sync="model.qcDate" :isRequired="true" :state="validateState('qcDate')" :errorMessage="getErrorMessage(errorMessage.qcDate, 'qcDate')"  :date-format-options="{ year: 'numeric', month: '2-digit', day: '2-digit' }" locale="en-GB" @change="updateData" :isEditable="false" :isUpdatable="false"/>
					</b-col>
					<b-col cols="12" lg="6">
				</b-col>

            </b-row>
        </b-card>

		<app-table-input-popup title="QC Result" :bordered="true" :items="finishGoodQcConfirmationDetails" :fields="fieldsFinishGoodQcConfirmationDetail" :busy="isDataLoading" :sort-by.sync="sortByFinishGoodQcConfirmationDetail" :sort-desc.sync="sortDescFinishGoodQcConfirmationDetail" small responsive
			@editButtonMethod="editRowDataFinishGoodQcConfirmationDetail"
			@deleteButtonMethod="deleteRowDataFinishGoodQcConfirmationDetail"
			@showPopupAddMethod="resetDataFinishGoodQcConfirmationDetail()"
			@showPopupUploadMethod="showPopupUploadFinishGoodQcConfirmationDetail()"
			@downloadMethod="downloadFinishGoodQcConfirmationDetail()"
			@addFromClipboardMethod="addFromClipboardFinishGoodQcConfirmationDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardFinishGoodQcConfirmationDetail()"
			:showActionButton="false"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadFinishGoodQcConfirmationDetail"
			>
			<template #top-row v-if="isShowFinishGoodQcConfirmationDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Finish Good Quality Inspection">
					<v-select append-to-body label="controlCard" :options="finishGoodQualityInspections"  :value="filterFinishGoodQcConfirmationDetail.finishGoodQualityInspectionId" :reduce="item => item.id" v-model="filterFinishGoodQcConfirmationDetail.finishGoodQualityInspectionId" @search="getFinishGoodQualityInspections" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Control Card">
					<v-select append-to-body label="controlCardNumber" :options="controlCards"  :value="filterFinishGoodQcConfirmationDetail.controlCardId" :reduce="item => item.id" v-model="filterFinishGoodQcConfirmationDetail.controlCardId" @search="getControlCards" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Part">
					<v-select append-to-body label="partNumber" :options="parts"  :value="filterFinishGoodQcConfirmationDetail.partId" :reduce="item => item.id" v-model="filterFinishGoodQcConfirmationDetail.partId" @search="getParts" :filterable="true"></v-select>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( finishGoodQcConfirmationDetailPageSize * (currentFinishGoodQcConfirmationDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(finishGoodQualityInspection)="row">
				<app-input-combobox-autocomplete :options="finishGoodQualityInspections" optionsLabel="controlCard" optionsKey="id" :id="'input-finish-good-qc-confirmation-detail-finish-good-quality-inspection-' + row.index" label-cols-lg="12" label="Finish Good Quality Inspection" size="sm" :model.sync="row.item.finishGoodQualityInspectionId"  @change="saveInputFinishGoodQcConfirmationDetail(row.item)" :selected="row.item.finishGoodQualityInspection != null ? row.item.finishGoodQualityInspection.controlCard : ''"  @input="getFinishGoodQualityInspections" :loading="isFinishGoodQualityInspectionComboLoading"  :isUpdatable="false"  :nolabel="true" />
			</template>
			<template v-slot:cell(controlCard)="row">
				<!-- <app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-finish-good-qc-confirmation-detail-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId"  @change="saveInputFinishGoodQcConfirmationDetail(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"  :isEditable="false" :isUpdatable="false"  :nolabel="true" /> -->
				<app-label label-cols-lg="12" size="sm" label="Control Card" :model="(row.item.controlCard != null) ? row.item.controlCard.controlCardNumber : null"  />
			</template>
			<template v-slot:cell(part)="row">
				<!-- <app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-finish-good-qc-confirmation-detail-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputFinishGoodQcConfirmationDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isUpdatable="false" :isEditable="false" :nolabel="true" /> -->
				<app-label label-cols-lg="12" size="sm" label="Part Number" :model="(row.item.part != null) ? row.item.part.partNumber : null"  />
			</template>
			<template v-slot:cell(partName)="row">
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null"  />
			</template>
			<template v-slot:cell(metodeQc)="row">
						<app-label label-cols-lg="12" size="sm" label="Metode Qc" :model="(row.item.finishGoodQualityInspection != null) ? (row.item.finishGoodQualityInspection.metodeQc != null) ? row.item.finishGoodQualityInspection.metodeQc.name : null : null"  />
			</template>
			<template v-slot:cell(qtyBefore)="row">
						<app-label label-cols-lg="12" size="sm" label="Qty Before" :model="(row.item.finishGoodQualityInspection != null) ? row.item.finishGoodQualityInspection.qtyBefore : null"  />
			</template>
			<template v-slot:cell(qtyOk)="row">
						<app-label label-cols-lg="12" size="sm" label="Qty OK" :model="(row.item.finishGoodQualityInspection != null) ? row.item.finishGoodQualityInspection.qtyAfter : null"  />
			</template>
			<template v-slot:cell(qtyPending)="row">
						<app-label label-cols-lg="12" size="sm" label="Qty Pending" :model="(row.item.finishGoodQualityInspection != null) ? row.item.finishGoodQualityInspection.qtyPending : null"  />
			</template>
			<template v-slot:cell(qtyNg)="row">
				<app-label :id="'input-finish-good-qc-confirmation-detail-qty-ng-' + row.index" label-cols-lg="12" size="sm" label="Qty Ng" :model="model.qtyNg" />
			</template>

			<template v-slot:form-add-detail>
				<FinishGoodQcConfirmationDetailInput 
					:openPopup="isShowPopupFinishGoodQcConfirmationDetail"
					:modelId="finishGoodQcConfirmationDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataFinishGoodQcConfirmationDetail"/>
			</template>
			<template v-slot:upload-detail>
				<FinishGoodQcConfirmationDetailUpload
					:openPopup="isShowPopupUploadFinishGoodQcConfirmationDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataFinishGoodQcConfirmationDetail"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-modal v-model="row.item._showDetails" title="Details" ok-only>					<b-card>
					<app-input-combobox-autocomplete :options="controlCards" optionsLabel="controlCardNumber" optionsKey="id" :id="'input-finish-good-qc-confirmation-detail-control-card-' + row.index" label-cols-lg="12" label="Control Card" size="sm" :model.sync="row.item.controlCardId"  @change="saveInputFinishGoodQcConfirmationDetail(row.item)" :selected="row.item.controlCard != null ? row.item.controlCard.controlCardNumber : ''"  @input="getControlCards" :loading="isControlCardComboLoading"  :isUpdatable="false" :isEditable="false"  :nolabel="false"  />
					<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-finish-good-qc-confirmation-detail-part-' + row.index" label-cols-lg="12" label="Part" size="sm" :model.sync="row.item.partId"  @change="saveInputFinishGoodQcConfirmationDetail(row.item)" :selected="row.item.part != null ? row.item.part.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"  :isUpdatable="false" :isEditable="false"  :nolabel="false"  />
							<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.part != null) ? row.item.part.partName : null"  />
							<app-label label-cols-lg="12" size="sm" label="Metode Qc" :model="(row.item.finishGoodQualityInspection != null) ? (row.item.finishGoodQualityInspection.metodeQc != null) ? row.item.finishGoodQualityInspection.metodeQc.name : null : null"  />
							<app-label label-cols-lg="12" size="sm" label="Qty Before" :model="(row.item.finishGoodQualityInspection != null) ? row.item.finishGoodQualityInspection.qtyBefore : null"  />
							<app-label label-cols-lg="12" size="sm" label="Qty OK" :model="(row.item.finishGoodQualityInspection != null) ? row.item.finishGoodQualityInspection.qtyAfter : null"  />
							<app-label label-cols-lg="12" size="sm" label="Qty Pending" :model="(row.item.finishGoodQualityInspection != null) ? row.item.finishGoodQualityInspection.qtyPending : null"  />
					<app-label :id="'input-finish-good-qc-confirmation-detail-qty-ng-' + row.index" label-cols-lg="12" size="sm" label="Qty Ng" :model="model.qtyNg" />
					</b-card>
				</b-modal>			</template>

		</app-table-input-popup>
        <!-- END_APP_DETAIL_HEADER -->

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import toast from '@/mixins/toastMixin';
import { required, minLength } from "vuelidate/lib/validators";
import FinishGoodQcConfirmation from '@/models/FinishGoodQcConfirmation/FinishGoodQcConfirmation';
import FinishGoodQcConfirmationList from '@/models/FinishGoodQcConfirmation/FinishGoodQcConfirmationList';
import FinishGoodQcConfirmationFilter from '@/filters/FinishGoodQcConfirmation/FinishGoodQcConfirmationFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppLabel from '@/components/AppLabel';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import UserInfo from '@/models/UserInfo/UserInfo';
import UserInfoFilter from '@/filters/UserInfo/UserInfoFilter';
import AppInputDatepicker from '@/components/AppInputDatepicker';
import AppInputDatepickerRange from '@/components/AppInputDatepickerRange';
import FinishGoodQcConfirmationDetail from '@/models/FinishGoodQcConfirmation/FinishGoodQcConfirmationDetail';
import FinishGoodQcConfirmationDetailFilter from '@/filters/FinishGoodQcConfirmation/FinishGoodQcConfirmationDetailFilter';
import FinishGoodQualityInspection from '@/models/FinishGoodQualityInspection/FinishGoodQualityInspection';
import FinishGoodQualityInspectionFilter from '@/filters/FinishGoodQualityInspection/FinishGoodQualityInspectionFilter';
import ControlCard from '@/models/ControlCard/ControlCard';
import ControlCardFilter from '@/filters/ControlCard/ControlCardFilter';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import FinishGoodQcConfirmationDetailInput from '@/views/FinishGoodQcConfirmation/FinishGoodQcConfirmationDetailInput';
import FinishGoodQcConfirmationDetailUpload from '@/views/FinishGoodQcConfirmation/FinishGoodQcConfirmationDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppLabel,
		AppInputComboboxAutocomplete,
		AppInputDatepicker,
		AppInputDatepickerRange,
		FinishGoodQcConfirmationDetailInput,FinishGoodQcConfirmationDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin, toast],
	validations: {
		model: {
			processById: {required},
			qcDate: {required},
			finishGoodQcConfirmationDetail: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				processById: { required : "QC By is Required."},
				qcDate: { required : "QC Date is Required."},
				finishGoodQcConfirmationDetail: { required : "QC Result is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsFinishGoodQcConfirmationDetail: [
				{"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none", "label" : "No"}}, 
				//{"finishGoodQualityInspection": { "class" : "th-finish-good-quality-inspection first-child", "label" : "Finish Good Quality Inspection", key: 'finishGoodQualityInspection', sortable: false, isRequired: false }}, 
				{"controlCard": { "class" : "th-control-card", "label" : "Control Card", key: 'controlCard', sortable: false, isRequired: false }}, 
				{"part": { "class" : "th-part last-child", "label" : "Part", key: 'part', sortable: false, isRequired: false }}, 
				{"partName": { "class" : "th-part-name d-stack-none", "label" : "Part Name", key: 'partName', sortable: false, isRequired: false }}, 
				{"metodeQc": { "class" : "th-metode-qc d-stack-none", "label" : "Metode Qc", key: 'metodeQc', sortable: false, isRequired: false }}, 
				{"qtyBefore": { "class" : "th-qty-before d-stack-none", "label" : "Qty Before", key: 'qtyBefore', sortable: false, isRequired: false }}, 
				{"qtyOk": { "class" : "th-qty-ok d-stack-none", "label" : "Qty OK", key: 'qtyOk', sortable: false, isRequired: false }}, 
				{"qtyPending": { "class" : "th-qty-pending d-stack-none", "label" : "Qty Pending", key: 'qtyPending', sortable: false, isRequired: false }}, 
				{"qtyNg": { "class" : "th-qty-ng d-stack-none", "label" : "Qty Ng", key: 'qtyNg', sortable: false, isRequired: false }}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {
				processById: null,
				qcDate: null,
				finishGoodQcConfirmationDetail: null,

			},
			modelFinishGoodQcConfirmationDetail : {},
			isShowPopupFinishGoodQcConfirmationDetail : false,
			isShowPopupUploadFinishGoodQcConfirmationDetail : false,
			filterFinishGoodQcConfirmation : null,
			currentFinishGoodQcConfirmationPage : 1,
			finishGoodQcConfirmationPageSize: 10,
			sortByFinishGoodQcConfirmation: '',
			sortDescFinishGoodQcConfirmation: '',
			filterFinishGoodQcConfirmationDetail : null,
			currentFinishGoodQcConfirmationDetailPage : 1,
			finishGoodQcConfirmationDetailPageSize: 10,
			sortByFinishGoodQcConfirmationDetail: '',
			sortDescFinishGoodQcConfirmationDetail: '',
			sortingByFinishGoodQcConfirmationDetail: [],
			finishGoodQcConfirmationDetails : [],
			finishGoodQcConfirmationDetailId : '',
			totalFinishGoodQcConfirmationDetailRow : 0,
			isShowFinishGoodQcConfirmationDetailFilter: false,
			isDownloadFinishGoodQcConfirmationDetail: false,
			finishGoodQualityInspections: [],
			controlCards: [],
			parts: [],
			userInfos: [],
			processBys: [],
			isProcessByComboLoading: false,
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			usePopup: false,
			isUserInfoComboLoading: false,
			isFinishGoodQcConfirmationComboLoading: false,
			isFinishGoodQualityInspectionComboLoading: false,
			isControlCardComboLoading: false,
			isPartComboLoading: false,
		}
	},
	methods : {
		doHidden(row, modalType){
			row.toggleDetails()
			this.resetModal(modalType)
		},
		showPopupWithMessage : async function(message) {
			const msg = this.$createElement;
			let msgNode = '';
			let result = false;
			msgNode = msg('div', { domProps: { innerHTML: '<p>'+message+'</p>' } })
			await this.$bvModal.msgBoxConfirm([msgNode], {
				title: 'Alert',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'success',
				cancelVariant: 'secondary',
				okTitle: 'Yes',
				cancelTitle: 'No',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			}).then(e=>{
				if(e){
					result = true;
				}
			});
			return result;
		},
		getFinishGoodQcConfirmation : async function(id) {
			this.isBusy = true;
			FinishGoodQcConfirmation.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadFinishGoodQcConfirmation = true;
			this.filterFinishGoodQcConfirmation.id = this.modelId;
			FinishGoodQcConfirmation.downloadDataDetail(this, this.filterFinishGoodQcConfirmation).then(result => {
				this.isDownloadFinishGoodQcConfirmation = false;
			}).catch(error => { this.isDownloadFinishGoodQcConfirmation = false; })
		},
		getFinishGoodQcConfirmationDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterFinishGoodQcConfirmationDetail);
			if (this.modelId == null) return;
			filter.finishGoodQcConfirmationId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByFinishGoodQcConfirmationDetail != null) {
				this.sortingByFinishGoodQcConfirmationDetail[this.sortByFinishGoodQcConfirmationDetail] = this.sortDescFinishGoodQcConfirmationDetail;
			}
			let currentPage = (this.currentFinishGoodQcConfirmationDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalFinishGoodQcConfirmationDetailRow + 1;
				let page = Math.ceil(totalData/this.finishGoodQcConfirmationDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.finishGoodQcConfirmationDetailPageSize = 0;
			// disable paging end
			FinishGoodQcConfirmationDetail.getList(this, filter, this.sortingByFinishGoodQcConfirmationDetail, currentPage , this.finishGoodQcConfirmationDetailPageSize).then(result => {
				this.currentFinishGoodQcConfirmationDetailPage = currentPage + 1;
				this.model.finishGoodQcConfirmationDetail = result.data;
				this.finishGoodQcConfirmationDetails = result.data;
				this.totalFinishGoodQcConfirmationDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getFinishGoodQcConfirmations : async function(input) {
			let filter = new FinishGoodQcConfirmationFilter();
			if (input != undefined) {
				filter.RequestNumber = input;
			}
			this.isFinishGoodQcConfirmationComboLoading = true;
			FinishGoodQcConfirmation.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.finishGoodQcConfirmations = result.data
				}
				this.isFinishGoodQcConfirmationComboLoading = false;
			})
			.catch(error => {});
		},
		getFinishGoodQcConfirmations : async function(input) {
			let filter = new FinishGoodQcConfirmationFilter();
			if (input != undefined) {
				filter.requestNumber = input;
			}
			this.isFinishGoodQcConfirmationComboLoading = true;
			FinishGoodQcConfirmation.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.finishGoodQcConfirmations = result.data
				}
				this.isFinishGoodQcConfirmationComboLoading = false;
			})
			.catch(error => {});
		},
		getFinishGoodQualityInspections : async function(input) {
			let filter = new FinishGoodQualityInspectionFilter();
			if (input != undefined) {
				filter.controlCard = input;
			}
			this.isFinishGoodQualityInspectionComboLoading = true;
			FinishGoodQualityInspection.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.finishGoodQualityInspections = result.data
				}
				this.isFinishGoodQualityInspectionComboLoading = false;
			})
			.catch(error => {});
		},
		getControlCards : async function(input) {
			let filter = new ControlCardFilter();
			if (input != undefined) {
				filter.controlCardNumber = input;
			}
			this.isControlCardComboLoading = true;
			ControlCard.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.controlCards = result.data
				}
				this.isControlCardComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		setSelectedProcessBy(item) {
			if(item == undefined || item == null) {
				this.model.processByUserName = null;
				this.model.processBy = null;
			} else {
				this.model.processByUserName = item.userName;
				this.model.processBy = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.finishGoodQcConfirmationInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				this.toast({ message: 'There are still mandatory fields that need to be filled in. Please double check your input.', title: 'Error', variant: 'danger', autoHideDelay:1500});
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					FinishGoodQcConfirmation.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'finishgoodqcconfirmationindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					FinishGoodQcConfirmation.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'finishgoodqcconfirmationindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData(state) {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					FinishGoodQcConfirmation.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getFinishGoodQcConfirmation(id);
					});
				}
			});
		},
		onHidden() {
			this.getFinishGoodQcConfirmations();
		},
		addRowDataFinishGoodQcConfirmationDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.finishGoodQcConfirmationId =  this.modelId;
					FinishGoodQcConfirmationDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getFinishGoodQcConfirmationDetails(true);
						this.isShowPopupFinishGoodQcConfirmationDetail = false;
					})
				} else {
					model.finishGoodQcConfirmationId =  this.modelId;
					FinishGoodQcConfirmationDetail.createDataDetail(this, model)
					.then(result => {
						this.getFinishGoodQcConfirmationDetails(true);
						this.isShowPopupFinishGoodQcConfirmationDetail = false;
					})
				}
			}
		},
		async editRowDataFinishGoodQcConfirmationDetail(id) {
			this.finishGoodQcConfirmationDetailId = id;
			this.isShowPopupFinishGoodQcConfirmationDetail = true; 
		},
		async deleteRowDataFinishGoodQcConfirmationDetail(id) {
			FinishGoodQcConfirmationDetail.deleteData(this, id).then(result => { this.getFinishGoodQcConfirmationDetails(); });
		},
		async resetDataFinishGoodQcConfirmationDetail() {
			this.finishGoodQcConfirmationDetailId = "";
			this.isShowPopupFinishGoodQcConfirmationDetail = true;
		},
		async addDataFinishGoodQcConfirmationDetail() {
			if(this.usePopup) {
				this.isShowPopupFinishGoodQcConfirmationDetail = true;
			} else {
				FinishGoodQcConfirmationDetail.createData(this, { finishGoodQcConfirmationId: this.modelId })
				.then(result => {
					this.getFinishGoodQcConfirmationDetails(true);
				})
			}
		},
		async addFromClipboardFinishGoodQcConfirmationDetail() {
			let finishGoodQualityInspections = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					finishGoodQualityInspections.push({ finishGoodQualityInspection: item, finishGoodQcConfirmationId: this.modelId });
				});
				FinishGoodQcConfirmationDetail.addFromClipboard(this, finishGoodQualityInspections).then(result => { this.getFinishGoodQcConfirmationDetails() });
			});
		},
		async replaceFromClipboardFinishGoodQcConfirmationDetail() {
			let finishGoodQualityInspections = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					finishGoodQualityInspections.push({ finishGoodQualityInspection: item, finishGoodQcConfirmationId: this.modelId });
				});
				FinishGoodQcConfirmationDetail.replaceFromClipboard(this, finishGoodQualityInspections).then(result => { this.getFinishGoodQcConfirmationDetails() });
			});   
		},
		showPopupUploadFinishGoodQcConfirmationDetail() {
			if(this.finishGoodQcConfirmationDetails != null && this.finishGoodQcConfirmationDetails.length > 0) {
				const msg = this.$createElement;
				const msgNode = msg('div', {
					domProps: {
						innerHTML: '<p>Perubahan terhadap FinishGoodQcConfirmationDetail akan me-reset data yang sudah diinput sebelumnya.</p><p>Apakah anda yakin akan melanjutkan?</p>'
					}
				});
				this.$bvModal.msgBoxConfirm([msgNode], {
					title: 'Confirmation',
					size: 'sm',
					buttonSize: 'sm',
					okVariant: 'success',
					cancelVariant: 'danger',
					okTitle: 'Yes',
					cancelTitle: 'No',
					footerClass: 'p-2',
					hideHeaderClose: false,
					centered: true
				})
				.then(value => {
					if (value) {
						this.isShowPopupUploadFinishGoodQcConfirmationDetail = true;
					}
				})
				.catch(err => {})
			} else {
				this.isShowPopupUploadFinishGoodQcConfirmationDetail = true;
			}
		},
		uploadDataFinishGoodQcConfirmationDetail(modalEvent, newDatas) {
			this.isShowPopupUploadFinishGoodQcConfirmationDetail = false; 
		},
		downloadFinishGoodQcConfirmationDetail(modalEvent) {
			this.isDownloadFinishGoodQcConfirmationDetail = true;
			this.filterFinishGoodQcConfirmationDetail.finishGoodQcConfirmationId = this.modelId;
			FinishGoodQcConfirmationDetail.downloadDataDetail(this, this.filterFinishGoodQcConfirmationDetail).then(result => {
				this.isDownloadFinishGoodQcConfirmationDetail = false;
			}).catch(error => { this.isDownloadFinishGoodQcConfirmationDetail = false; })
		},
		saveInputFinishGoodQcConfirmationDetail(item) {
			if (this.finishGoodQcConfirmations != null && this.finishGoodQcConfirmations != undefined  && this.finishGoodQcConfirmations.length > 0) {
				item.finishGoodQcConfirmation = this.finishGoodQcConfirmations.find(q => q.id == item.finishGoodQcConfirmationId);
			}
			if (this.finishGoodQualityInspections != null && this.finishGoodQualityInspections != undefined  && this.finishGoodQualityInspections.length > 0) {
				item.finishGoodQualityInspection = this.finishGoodQualityInspections.find(q => q.id == item.finishGoodQualityInspectionId);
			}
			if (this.controlCards != null && this.controlCards != undefined  && this.controlCards.length > 0) {
				item.controlCard = this.controlCards.find(q => q.id == item.controlCardId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.part = this.parts.find(q => q.id == item.partId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					FinishGoodQcConfirmationDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadFinishGoodQcConfirmationDetail = false; 
			this.isShowPopupFinishGoodQcConfirmationDetail = false; 
			if (modalType == 'FinishGoodQcConfirmationDetail') {
				this.getFinishGoodQcConfirmationDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowFinishGoodQcConfirmationDetailFilter = true;
			}

			if(this.windowWidth <= 576) {
				this.usePopup = true
			} else {
				this.usePopup = false
			}
		},
	},
	beforeMount() {
		this.filterFinishGoodQcConfirmation = new FinishGoodQcConfirmationFilter();
		this.filterFinishGoodQcConfirmationDetail = new FinishGoodQcConfirmationDetailFilter();
		//this.getFinishGoodQcConfirmations();
		//this.getFinishGoodQualityInspections();
		//this.getControlCards();
		//this.getParts();
		//this.getUserInfos();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getFinishGoodQcConfirmation(id);
			} else {
				this.modelId = id;
				this.getFinishGoodQcConfirmation(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByFinishGoodQcConfirmationDetail : {
			handler: function() {
				this.getFinishGoodQcConfirmationDetails();
			}
		},
		sortDescFinishGoodQcConfirmationDetail: {
			handler: function() {
				this.getFinishGoodQcConfirmationDetails();
			}
		},
		currentFinishGoodQcConfirmationDetailPage: {
			handler: function() {
				this.getFinishGoodQcConfirmationDetails();
			}
		},
		finishGoodQcConfirmationDetailPageSize : {
			handler: function() {
				this.getFinishGoodQcConfirmationDetails();
			}
		},
		filterFinishGoodQcConfirmationDetail: {
			handler: function() {
				this.getFinishGoodQcConfirmationDetails();
			},
			deep: true,
		},
	},
}
</script>
